import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { HomeComponent } from './home/home.component';
import { ProfileComponent } from './profile/profile.component';
import { BoardPoiliciesComponent } from "./board-poilicies/board-poilicies.component";
import { MsalGuard } from '@azure/msal-angular';
import { CounterComponent } from './Components/counter/counter.component';
import { UserComponent } from './Components/user/user.component';
import { PolicyComponent } from './Components/policy/policy.component';
import { SoftwareInfoComponent } from './Components/SMM/software-info/software-info.component';
import { CategoryComponent } from './Components/category/category.component';
import { PolicyManagementComponent } from './Components/policy-management/policy-management.component';
import { PrincipalComponent } from './Components/PrincipalInfo/principal/principal.component';
import { PolicyPDFViwerComponent } from './Components/policy-pdfviwer/policy-pdfviwer.component';

const routes: Routes = [
  { path: 'profile', component: ProfileComponent, canActivate: [MsalGuard] },
  { path: 'boardpolicies', component: BoardPoiliciesComponent },
  { path: 'policies', component: PolicyComponent },
  { path: 'policymanagement', component: PolicyManagementComponent },
  { path: 'user', component: UserComponent },
  { path: 'category', component: CategoryComponent },
  { path: 'principal', component: PrincipalComponent},
  { path: 'policypdfviwer/:filename', component: PolicyPDFViwerComponent, pathMatch: "full" },
  // { path: 'softwarelist', component: SoftwareInfoComponent },
  { path: '', component: PolicyComponent },
];

const isIframe = window !== window.parent && !window.opener;

@NgModule({
  imports: [RouterModule.forRoot(
    routes, 
    {
      //initialNavigation: !isIframe ? 'enabledNonBlocking' : 'disabled'
      //initialNavigation: !isIframe ? 'enabled' : 'disabled' // Don't perform initial navigation in iframes
    },
  )],
  exports: [RouterModule]
})
export class AppRoutingModule { }
